export default {
    login1: '已有账号？',
    login2: '去登录',
    login3: '重置密码？',
    login4: '开始使用51shopy',
    login5: '忘记密码?',
    login6: '立即注册',
    login7: '邮箱',
    login8: '验证码',
    login9: '输入验证码',
    login10: '密码',
    login11: '确认密码',
    login12: '请再次输入密码',
    login13: '注册',
    login14: '下一步',
    login15: '提交',
    login16: '发送验证码',
    login17: '请输入正确的邮箱和验证码！',
    login18: '两次输入密码不一致!',
    login19: '验证码已发送',
    login20: '邮箱不能为空',
    login21: '邮箱格式不正确',
    login22: '验证码不能为空',
    login23: '验证码长度为4个字符',
    login24: '密码不能为空',
    login25: '密码长度不能小于6位',
    login26: '密码修改成功！',
    login27: '注册成功！',
    login28: '登录成功',
    login29: '账号名不能为空',
    login30: '在下面登录您的帐户以开始使用',
    login31: '账号',
    login32: '点击登录',
    login33: "购买优质商品，享受红利",
    login34: "注册以享受一份精美的礼物",
    login35: "登录",
    login36: "注册",

    home1: '热门',
    home2: '确定注销并退出吗？',
    home3: '提示',
    home4: '确定',
    home5: '取消',
    home6: '粉丝',
    home7: '关注',
    home8: '个人中心',
    home9: '我买入的',
    home10: '我卖出的',
    home11: '我的钱包',
    home12: '退出',
    home13: '共',
    home14: '件商品',
    home15: '结算',
    home16: '价格亲民',
    home17: '物流快捷',
    home18: '质量保证',
    home19: '关于我们',
    home20: '帮助中心',
    home21: '售后服务',
    home22: '配送与验收',
    home23: '商务合作',
    home24: '搜索推荐',
    home25: '友情链接',
    home26: '关注',
    home27: '已关注',
    home28: '立即购买',
    home29: '加入购物车',
    home30: '收藏成功！',
    home31: '取消收藏成功！',
    home32: '确定取消关注?',
    home33: '取消成功！',
    home34: '关注成功！',
    home35: '内容不能为空',
    home36: '评论成功!',
    home37: '商品评价',
    home38: '立即评价',
    home39: '评价',
    home40: '历史记录',
    home41: '取消关注成功！',
    home42: '这个家伙很神秘，没有写个人简介。',
    home43: '首页',
    number1: '我的账户',
    number2: '个人中心',
    number3: '钱包',
    number4: '我的收藏',
    number5: '我的关注',
    number6: '我的粉丝',
    number7: '历史浏览',
    number8: '交易管理',
    number9: '我发布的',
    number10: '我买入的',
    number11: '我卖出的',
    number12: '购物车',
    number13: '个人主页',
    number14: '客服',
    number15: '设置',
    number16: '新增地址',
    number17: '修改地址',
    number18: '只能上传图片文件!',
    number19: '文件大小不能超过 10MB!',
    number20: '图片上传成功',
    number21: '余额',
    number22: '收藏商品',
    number23: '个人信息',
    number24: '编辑',
    number25: '提交',
    number26: '昵称',
    number27: '个人简介',
    number28: '收货地址',
    number29: '添加',
    number30: '默认',
    number31: '未支付',
    number32: '待发货',
    number33: '已完成',
    number34: '已取消',
    number35: '待审核',
    number36: '已通过',
    number37: '已驳回',
    number38: '订单完成',
    number39: '订单支付成功!',
    number40: '订单取消成功！',
    number41: '提现成功！',
    number42: '充值',
    number43: '提现',
    number44: '消费历史',
    number45: '订单编号',
    number46: '支付名称',
    number47: '全部',
    number48: '查询',
    number49: '订单号',
    number50: '支付名称',
    number51: '51币',
    number52: '订单状态',
    number53: '订单创建时间',
    number54: '订单更新时间',
    number55: '操作',
    number56: '已支付',
    number57: '取消订单',
    number58: '详情',
    number59: '编号',
    number60: '已发货',
    number61: '待处理',
    number62: '提现记录',
    number63: '用户id',
    number64: '提现金额',
    number65: '状态',
    number66: '创建时间',
    number67: '钱包提现',
    number68: '提现',
    number69: '钱包订单详情',
    number70: '全部订单',
    number71: '待付款',
    number72: '待发货',
    number73: '已完成',
    number74: '已取消',
    number75: '已支付',
    number76: '全部发货',
    number77: '物流单号',
    number78: '发货成功!',
    number79: '我卖出的',
    number80: '暂无订单数据',
    number81: '订单号',
    number82: '下单时间',
    number83: '下单人',
    number84: '更改时间',
    number85: '订单详情',
    number86: '合计',
    number87: '已发货',
    number88: '详情',
    number89: '填写物流单号',
    number90: '物流单号',
    number91: '请输入物流单号',
    number92: '取消成功!',
    number93: '成功!',
    number94: '订单延迟收货成功!',
    number95: '我买入的',
    number96: '立即付款',
    number97: '确认收货',
    number98: '延迟收货',
    number99: '取消订单',
    number100: '卖家用户',
    number101: '我收藏的',
    number102: '我的粉丝',
    number103: '我关注的',
    number104: '支付名称',
    number105: '51币',
    number106: '订单状态',
    number107: '支付时间',
    number108: '我已支付',
    number109: '订单支付成功！',
    number110: '全部商品',
    number111: '确定删除商品?',
    number112: '删除成功！',
    number113: '取消成功！',
    number114: '确定上架商品?',
    number115: '确定下架商品?',
    number116: '成功！',
    number117: '上架',
    number118: '下架',
    number119: '删除',
    number120: '查看详情',
    cart1: '商品信息',
    cart2: '单价',
    cart3: '数量',
    cart4: '小计',
    cart5: '操作',
    cart6: '单价',
    cart7: '确认删除吗?',
    cart8: '确认',
    cart9: '取消',
    cart10: '删除',
    cart11: '购物车列表为空',
    cart12: '件商品，商品合计',
    cart13: '商品合计',
    cart14: '结算',
    cart15: '添加地址',

    cart16: 'telegram和watchApp必须填写一个',
    cart17: '用户信息配置成功!',
    cart18: '请选择或填写收货地址！',
    cart19: '订单创建成功！',
    cart20: '收货地址',
    cart21: '您需要先添加收货地址才可提交订单。',
    cart22: '收货人',
    cart23: '联系方式',
    cart24: '收货地址',
    cart25: '切换地址',
    cart26: '添加地址',
    cart27: '商品信息',
    cart28: '单价',
    cart29: '数量',
    cart30: '实付',
    cart31: '总价',
    cart32: '金额明细',
    cart33: '应付总额',
    cart34: '提交订单',
    cart35: '切换收货地址',
    cart36: '取消',
    cart37: '确定',
    cart38: '用户信息',
    cart39: '提交',
    cart40: '姓不能为空',
    cart41: '名不能为空',
    cart42: '手机号不能为空',
    cart43: '国家不能为空',
    cart44: '省/直辖市/区不能为空',
    cart45: '市不能为空',
    cart46: '详细地址不能为空',
    cart47: '邮政编码不能为空',
    cart48: '地址修改成功！',
    cart49: '地址添加成功！',
    cart50: '姓',
    cart51: '名',
    cart52: '国家',
    cart53: '省/直辖市/区',
    cart54: '市',
    cart55: '详细地址',
    cart56: '邮政编码',
    cart57: '联系电话',
    cart58: '是否默认',
    cart59: '首页',
    cart60: '客服',
    cart61: '发布',
    cart62: '我的',
    cart63: '购物车',
    cart64: '发货时间',
    cart65: '付款时间',
    cart66: '收货信息',
    cart67: '实付款',
    cart68: '送至',
    cart69: '商品',
    cart70: '您可以 申请开票',
    cart71: '订单信息',
    cart72: '商家',
    cart73: '提交成功！',
    cart74: '复制成功',
    cart75: '复制失败',
    cart76: '比例',
    cart77: '信用额度',
    cart78: '转账',
    cart79: '充值金额',
    cart80: '充值',
    cart81: '分类',
    setup1: '个人信息',
    setup2: '我的收货地址',
    setup3: '我的档案',
    setup4: '账号与安全',
    setup5: '隐私',
    setup6: '通用',
    setup7: '帮助与反馈',
    setup8: '关于我们',
    setup9: '退出登录',
    setup10: '站内信',
    setup11: '暂无数据',
    setup12: '加入购物车成功!',
    setup13: '加入购物车失败!',

    setup14: '商品编辑',
    setup15: '商品发布',
    setup16: '商品封面图',
    setup17: '商品分类',
    setup18: '商品名称',
    setup19: '商品价格(CNY)',
    setup20: '商品描述',
    setup21: '商品图片(最多上传10张图片)',
    setup22: '重置',
    setup23: '商品创建成功！',


    setup24: '商品库存不足！',
    setup25: '支付方式',
    setup26: '51币',
    setup27: '转账',
    setup28: '产品链接或名称/商品链接',
    setup29: '用户不是卖家,不能发布商品！',
    setup30: '检测到非人为操作的哦！',
    setup31: '商品库存',
    setup32: '浏览量',
    setup33: '订单提交成功！',
    setup34: '查看订单',
    setup35: '商品库存',
    setup36: '商品分类不能为空',
    setup37: '商品名称不能为空',
    setup38: '商品描述不能为空',
    setup39: '商品库存不能为空',
    setup40: '商品价格不能为空',
    setup41: '封面图片不能为空',
    setup42: '商品图片不能为空',
    setup43: '已转账待确认',
    setup44: '请选择转账方式！',
    setup45: '完成时间',
    setup46: '51币支付',
    setup47: '转账支付',
    setup48: '转账方式',
    setup49: "商品详情",
    setup50: "买家",
    setup51: "商品运费为",
    setup52: "运费",
    setup53: "销售数量",
    setup54: "最低购买数量",
    setup55: "新增地址",
    setup56: "已付款",
    setup57: "收款方联系方式",
    setup58: "商家联系方式",
    setup59: "买家联系方式",
    setup60: "复制",
    setup61: "热门",
    setup62: "至少填写一个字段",
    setup63: "联系我们",
    setup64: "运费估算",
    setup65: "订阅我们",
    setup66: "海外网红合作",
    setup67: "支付及售后问题",
    setup68: "用户分红",

    setup69: "货币类型",
    setup70: "汇率",
    setup71: "手续费",
    setup72: "实际到账",
    setup73: "最低提现金额",
    setup74: "币种",
    setup75: "手续费",
    setup76: "实际到账",

    setup78: "邀请码",
    setup79: "请输入邀请码",
    setup80: "手机区号不能为空",
    setup81: "区号",
    setup82: "取消时间",
    setup83: "提现详情",
    setup84: "分红明细",
    setup85: "是否过期",
    setup86: "是否使用",
    setup87: "未过期",
    setup88: "已过期",
    setup89: "未使用",
    setup90: "已使用",
    setup91: "部分使用",
    setup92: "返利",
    setup93: "已用返利",
    setup94: "剩余返利",
    setup95: "是否使用",
    setup96: "是否过期",
    setup97: "失效时间",
    setup98: "返利时间",
    setup99: "联盟分享",
    setup100: "取消支付",
    setup101: "关闭界面",
    setup102: "USDT支付",
    setup103: "实际支付金额",
    setup104: "订单交易金额",
    setup105: "网络",
    setup106: "您支付网络费用",
    setup107: "支付成功",
    setup108: "收款人钱包地址",
    setup109: "请认真核对实际支付的金额与您转账的金额一致，如果出错后果自行承当",
    setup110: "过期时间",
    setup111: "等待支付",
    setup112: "支付成功",
    setup113: "订单过期",
    setup114: "检查区块链交易",
    setup115: "",
    setup116: "",
    setup117: "",
    setup118: "",
    setup119: "",

    setup130: "关于我们",
    setup131: "配送相关",
    setup132: "其他",
    setup133: "运输政策",
    setup134: "包裹派件/取件时间",
    setup135: "服务条款",
    setup136: "付款方式",
    setup137: "退货政策",
    setup138: "隐私政策",
    setup139: "太空網絡科技有限公司 ",
    setup140: "工作时间：",
    setup141: "联系人：",
    setup142: "公司邮箱：",
    setup143: "邮编：",
    setup144: "地址: ",

    setup0140: "周一至周五（9:00-18:00）",
    setup0141: " Mr. Liang",
    setup0143: "999077",
    setup0144: "香港觀塘開源道 56 號大眾工業大廈 3 樓 341 室",

    setup145: "国际包裹运输协议",
    setup146: "鉴于国际运输的特殊性，您需要遵守国际包裹运输规则，请您务必仔细阅读并接受以下条款和条件。",
    setup147: "套餐补偿标准：",
    setup148: "如果由于51shopy无法控制的原因导致您的产品在运输过程中丢失、缺少数量、损坏、延误或被海关扣押，51shopy不承担赔偿责任。对于间接的、未实现的利润损失，我们也不承担任何赔偿责任。实际详情请参见“包裹保险及赔偿”。",
    setup149: "以下情况，51shopy不负责赔偿（对于未投保的包裹）：",
    setup150: "1、因自然灾害或海关原因等不可抗力造成邮件丢失，不予赔偿；",
    setup151: "2、寄递物品违反禁止、限制规定的，主管机关将没收或依照有关法律法规进行处理，且不予赔偿；",
    setup152: "3、寄件时，如邮件包装完好、无拆解痕迹、重量未减轻但内部零件短少或损坏，则不予赔偿；",
    setup153: "4、如邮件轨迹显示未正常投递，经物流商确认包裹已被海关没收，以物流商查询为准，不予赔偿；",
    setup154: "5、因客户责任或寄件本身原因造成邮件丢失或内容短缺，不予赔偿；",
    setup155: "6、自邮件送达之日起至查询期限届满期间，客户未查询且未提出索赔的，将不予赔偿；",
    setup156: "7、国际邮件如被寄达国根据其国内法律扣留、没收或销毁，将不予赔偿。",
    setup157: "违禁物品",
    setup158: "遵守我国国家关于禁寄、限寄物品的规定：",
    setup159: "1、遵守国家邮政局、公安部、国家安全部关于发布《禁寄物品管理规定》的公告。",
    setup160: "2、遵守海关总署令第43号（《中华人民共和国禁止、限制进出境物品清单》）的规定。",
    setup161: "无法通过邮件运送的物品",
    setup162: "1、国家法律规定禁止流通、运输的物品。",
    setup163: "2、爆炸性、易燃性、腐蚀性、放射性或有毒危险物品。",
    setup164: "3、含有反动内容或淫秽内容的出版物、书籍、资料或物品。",
    setup165: "4、各种货币。",
    setup166: "5、违反公共卫生的物品。",
    setup167: "6、容易腐烂的物品。",
    setup168: "7、活体动物（蜜蜂、蚕、水蛭除外，只要包装保证工人的安全即可）。",
    setup169: "8、包装不充分，可能对工人造成危险，或污染或损坏其他包装的物品。",
    setup170: "9、其他不适合邮寄的物品。",
    setup171: "根据邮政惯例禁止寄递的物品",
    setup172: "1、质量或包装可能对邮政工作人员造成伤害或污染/损坏其他包裹或邮政设备的物品。",
    setup173: "2、带有金属封条或其他可能妨碍邮政处理的锋利边缘的物品。",
    setup174: "3、各类枪支、弹药、爆炸性、易燃性、腐蚀性、放射性物品或容器、烈性毒药、麻醉药品、生化制品及传染性物品。",
    setup175: "4、各种可能危害社会安全、稳定或者含有淫秽内容的出版物、宣传品、印刷品。",
    setup176: "5、各种可能危害公众健康的物品。",
    setup177: "6、接收国不接受或不允许流通的文件或物品。",
    setup178: "可用的付款方式",
    setup179: "网站支持多种支付方式，信用卡/借记卡，Wechat，Alipay等，如果您需要频繁支付或者托管扣款，您还可以使用余额支付。",
    setup180: "  - 信用卡/借记卡的代购订单支付如发生退款，将退款到原账号；余额充值的退款也将退款到原账号",
    setup181: "  - Wechat，Alipay等订单支付如发生退款，将退款到原账号；",
    setup182: "  - 余额付款如发生退款，将退款到账户余额；",
    setup183: "51shopy用户隐私政策",
    setup184: "您的个人信息安全对我们非常重要，我们非常重视您的信任。在任何情况下，我们都不会向第三方出售或披露您的个人信息。我们将保护您向我们提供的任何个人信息的安全性和隐私性，并且只会使用我们在此处描述的信息。如果您对本隐私政策有任何疑问、建议或意见，您可以随时通过访问51shopy在线客服系统或51shopy官方服务号与我们联系。",
    setup185: "本政策不适用于其他第三方向您提供的服务，也不适用于我们独立设定隐私政策的服务。",
    setup186: "请在使用51shopy服务前仔细阅读并透彻理解本政策。您同意本隐私政策代表您已了解本应用所提供的功能以及运行该功能所需的必要个人信息。",
    setup187: "相关注册用户服务的所有权及运作权归属于",
    setup188: "1.我们收集哪些个人信息？",
    setup189: "您可以选择使用或访问我们的网站而不透露任何有关您的个人和交易信息，但您需要注册一个帐户才能体验我们的完整服务，如果您向我们提供您的信息，则表示您同意将信息传输并存储在我们的服务器上。",
    setup190: "51shopy收集您在使用本网站时提供的个人信息，这些信息包括您的姓名、联系方式、电子邮件地址、51shopy账户名和密码以及您创建账户所需的其他信息。除了我们在注册时可能收集和处理的个人信息外，我们还收集、存储和处理有关我们在51shopy上的用户的以下信息：",
    setup191: "1）购买信息",
    setup192: "2）服务账户信息",
    setup193: "3）付款信息（付款时间、付款金额、付款渠道等）",
    setup194: "4）搜索浏览记录信息（搜索内容、链接点击行为、浏览记录、点击查看记录等）",
    setup195: "5）Cookie 和其他计算机信息",
    setup196: "我们与 Microsoft Clarity 和 Microsoft Advertising 合作，通过行为指标、热图和会话重播来捕获您如何使用和与我们的网站互动，以改进和营销我们的产品/服务。使用第一方和第三方 cookie 以及其他跟踪技术捕获网站使用数据，以确定产品/服务和在线活动的受欢迎程度。此外，我们将这些信息用于网站优化、欺诈/安全目的和广告。有关 Microsoft 如何收集和使用您的数据的更多信息，请访问",
    setup197: "Microsoft 隐私声明",
    setup198: "2.我们如何使用您的个人信息？",
    setup199: "我们不会出售或泄露任何用户的个人信息，并努力保护您的信息和隐私。我们将使用您的信息为您提供更好的服务，包括：",
    setup200: "1）通过电子邮件与您联系并向您提供我们的一系列服务，包括咨询服务、订单信息服务、包裹信息服务、商品售后服务等。",
    setup201: "2）通过电子邮件、内部信件等方式向您传达平台活动，包括向您提供优惠券、运费折扣和特别促销活动，以及提供使用第三方服务的机会。",
    setup202: "3）当您在51shopy搜索、浏览我们合作商家的链接时，您的51shopy用户ID、相关操作行为及信息（搜索内容、链接点击行为、浏览记录、点击查看记录等）将同步提供给该操作行为链接对应的来源方，以方便我们与合作商家共同为您提供优质高效的服务，您可以点击查看51shopy合作商家（www.taobao.com、www.1688.com）。",
    setup203: "根据法律法规及国家标准，以下情形中，合作方使用、转移、披露您的个人信息无需经过您的授权同意：",
    setup204: "1）根据法律、法规、行政、司法机关的强制要求和其他法定义务；",
    setup205: "2）在法律法规允许的范围内，为维护社会公共利益、财产安全、保护您或其他51shopy用户、51shopy、51shopy的关联公司或合作伙伴免受损害而有必要；",
    setup206: "3) 对于实现我们产品和/或服务的核心功能，或者提供您需要的服务所必需的；",
    setup207: "4) 在合理的范围内处理您自行披露的您的个人信息或其他已经合法披露的个人信息（例如通过合法的新闻报道、政府信息公开或其他渠道合法披露的个人信息）；",
    setup208: "5）根据您的需要处理您与其他人之间的纠纷或争议；",
    setup209: "6)遵守与您签署的相关协议（包括网络电子协议及相应的平台规则）或其他法律文件的规定；",
    setup210: "7）基于社会公共利益以及突发公共卫生事件等情况并符合法律法规要求的使用。",
    setup211: "为了上述目的，您也有权随时取消该通知，您可以登录51shopy网站在自定义功能中自行设置。",
    setup212: "请注意，除非获得您的同意，否则我们不会与任何广告商共享您的个人数据。未经监护人同意、知情和在场，我们不会向儿童或其他无行为能力的人索取或发布个人信息。",
    setup213: "您在此知悉、共享和转让去标识化后的个人信息，并保证数据接收者无法复原并重新识别个人信息主体，不构成个人信息向外界共享、转让和公开披露，该类数据的保存和处理无需向您通知并征得您的同意。",
    setup214: "我们可能会委托授权合作伙伴处理您的个人信息，以授权合作伙伴代表我们为您提供某些服务或执行某些功能。我们仅会出于本政策声明合法、正当、必要、特定和明确的目的委托处理您的信息，授权合作伙伴只能接触履行职责所必需的信息。51shopy不会将您的电子邮箱地址、51shopy网站账户名和密码、联系方式等隐私信息提供给我们的合作伙伴。",
    setup215: "3.我们将保留您的信息多久？",
    setup216: "一旦您成功注册51shopy账户，我们将永久保存您的个人信息，如果您想注销您的账户或者删除您的个人信息，请联系在线客服。",
    setup217: "根据GDPR，数据控制者和处理者有义务在服务结束后或合同或协议到期后归还或删除所有个人数据，除非法律规定需要保留数据。",
    setup218: "4.我们如何保护您的个人信息",
    setup219: "我们将采取一切合理可行的措施保护您的个人信息。我们将采取一切合理可行的措施确保不收集无关的个人信息。",
    setup220: "5.政策更新",
    setup221: "为了给您带来更好的产品和服务体验，我们不断努力改进我们的产品、服务和技术。当新的服务和业务流程发生变化时，我们可能会更新我们的隐私政策，以告知您具体变化。请您及时关注本页面，以页面上最新的政策为准。最新政策一经发布，即对您具有约束力。",
    setup222: "6.联系我们",
    setup223: "如果您对隐私声明有任何疑问，请联系：  ",
    setup224: "请您在注册成为用户前仔细阅读《51shopy服务条款》，并确保您已充分理解这些条款。请您审慎阅读并选择接受或不接受《51shopy服务条款》，特别是免除或限制责任、法律适用和争议解决的条款。除非您接受本《51shopy服务条款》，否则您无权注册、登录或使用51shopy服务。您的注册、登录和使用将被视为您接受《51shopy服务条款》，并同意接受《51shopy服务条款》的约束。",
    setup225: "《51shopy服务条款》规定了您和51shopy就51shopy服务（以下简称“服务”）的权利义务。本《51shopy服务条款》可能由51shopy随时更新，更新后的《51shopy服务条款》一经发布并公示即代替原来的条款，无需另行通知。您可以在51shopy平台查阅最新版本的《51shopy服务条款》。同时建议您及时了解更新后的《51shopy服务条款》，以避免不必要的误解和纠纷。《 51shopy服务条款》修改后，如果您不接受修改后的条款，请立即停止使用51shopy提供的服务，您继续使用51shopy提供的服务将被视为接受修改后的《 51shopy服务条款》。",
    setup226: "1.本服务条款的适用范围",
    setup227: "相关注册用户服务的所有权及运作权归属于，所提供的服务必须依照其发布的服务规则、条款及操作规范执行，亦代表相关用户与51shopy已达成协议并接受其所有服务条款。",
    setup228: "2.信息收集和使用",
    setup229: "当您使用51shopy的服务时，我们可能需要收集和使用的您的个人信息包括以下两种类型：",
    setup230: "1.为了向您提供我们服务的基本功能，您必须授权我们收集和使用必要的信息。如果您拒绝提供相应的信息，您将无法正常注册、登录或使用我们的服务；",
    setup231: "2.为了向您提供我们服务的附加功能，您可以单独选择同意或不同意我们收集和使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或实现我们拟实现的功能效果，并且不会影响您使用我们的基本功能。",
    setup232: "我们依法保护您在安装或使用过程中的知情权和选择权。在您使用51shopy服务过程中，涉及您设备上提供的功能的服务需要事先获得您的同意。经您确认后，51shopy有权开启收集地理位置、读取通讯录、使用摄像头、开启录音服务等必要的辅助功能。",
    setup233: "收集、使用的信息包括但不限于用户的姓名、联系方式等基本信息，用户同意该信息的使用受第三条“用户信息保护”的规定。",
    setup234: "3.用户信息保护",
    setup235: "我们不会向第三方披露或透露您的个人信息，除非：",
    setup236: "1.履行法律义务所必需的共享；",
    setup237: "2.经您同意的共享；",
    setup238: "4.用户权利和义务",
    setup239: "1.您有权登录51shopy网站查阅、更正和补充您的个人信息。",
    setup240: "2.您有权联系在线客服申请注销您的账号。您主动注销账号后，我们将停止为您提供服务，并根据相关法律的要求删除或匿名化处理您的个人信息。",
    setup241: "3.在某些业务功能中，我们可能仅依据包括算法在内的非人工自动决策机制做出决定。如果这些决定影响到您的合法权益，您可以通过客服与我们联系。",
    setup242: "4.您向51shopy提供的所有信息均应真实、准确且不具有误导性。",
    setup243: "您理解并同意，您有义务维护您提供的信息的真实性和有效性。",
    setup244: "5.您不得利用您的注册账户或51shopy服务制作、上传、复制、发布或传播干扰51shopy正常运行或者侵犯其他用户或第三方合法权益的内容。",
    setup245: "6.您不得复制、抄袭、出售、转售或为任何其他商业目的使用51shopy服务的任何部分或通过51shopy服务使用或获取的内容。",
    setup246: "7.您应对通过您的51shopy账户或51shopy服务传输的任何信息的真实性、合法性、准确性和有效性承担全部责任。与您传输的任何信息有关的任何法律责任均由您自行承担，与51shopy无关。因此给51shopy或任何第三方造成的任何损失，您应予以赔偿，51shopy保留向相关用户及用户追究责任的权利。",
    setup247: "8.您应对您账户下的所有行为（包括但不限于在网上签署各类协议、发布信息、购买商品和服务、披露信息）的结果承担全部责任。",
    setup248: "5.信息存储",
    setup249: "“51shopy”对传输的信息量不设上限，我们已采取符合业界标准的合理可行的安全保护措施保护您的信息，防止个人信息遭到未经授权的访问、公开披露、使用、修改、损坏或丢失，另请您妥善保护您的个人信息，仅在必要的情形下向他人提供，且不要轻信通过其他交易工具进行交易，以免遭受信息窃取甚至网络诈骗。",
    setup250: "6. 责任免除",
    setup251: "1.51shopy提供的商品信息会尽可能还原真实情况，但由于商品拍摄过程中受到周围环境、拍摄角度、设备差异等多种因素的影响，我们无法保证商品与实物一模一样。",
    setup252: "2.51shopy根据用户指定的平台购买指定商品，如您指定的平台出现缺货、价格变动、发货不及时、实际商品与网站商品信息不符、商品异常或其他不可抗拒因素导致无法正常购买，我们将及时与您沟通，因此给您造成的损失，“51shopy”不承担任何责任。",
    setup253: "3.您在51shopy购买的商品如涉及售后问题（如缺货、破损、缺陷等），我们将及时为您处理。",
    setup254: "4.因您主动披露51shopy帐号或因他人攻击、诈骗等行为造成的任何损失或后果，51shopy不承担任何责任，您应当通过司法救济或其他方式向侵权人寻求赔偿。",
    setup255: "7.禁止行为",
    setup256: "您不得使用51shopy服务进行以下活动：",
    setup257: "（1）违反任何法律、法规、法令或规章。",
    setup258: "（2）涉及以下交易：",
    setup259: "(a) 麻醉品、类固醇、某些受管制药物或其他可能危害消费者安全的产品；",
    setup260: "(b) 毒品用具；",
    setup261: "(c)香烟；",
    setup262: "(d) 未经许可的大麻或其他精神活性植物；",
    setup263: "(e) 基于订阅的营养、维生素、补充剂、草药、天然保健产品；",
    setup264: "(f) 教唆、诱导、协助或指挥他人从事非法活动的物品；",
    setup265: "(g) 被盗物品，包括数字物品和虚拟物品；",
    setup266: "(h) 煽动仇恨、暴力、种族或其他形式偏见或利用犯罪活动的物品；",
    setup267: "(i) 被视为淫秽；",
    setup268: "(j) 侵犯或侵害任何司法管辖区法律规定的版权、商标、宣传或隐私或任何其他专有权利的物品；",
    setup269: "(k) 某些色情物品或服务；",
    setup270: "(l) 弹药、武器或某些武器零件或配件，或",
    setup271: "(m) 适用法律管制的某些武器或刀具。",
    setup272: "（3）与下列交易有关：",
    setup273: "(a) 披露第三方的个人信息违反相关法律；",
    setup274: "(b) 支持金字塔骗局、庞氏骗局、矩阵骗局、其他快速致富计划或某些多层次下线计划；",
    setup275: "(c) 与购买年金或彩票合同、预付存款购买系统、离岸银行业务或为信用卡债务融资或再融资的交易有关的交易；",
    setup276: "(d) 在卖方控制或占有某些物品之前出售该物品；",
    setup277: "(e) 支付处理商代表商家收取付款；",
    setup278: "(f) 与销售旅行支票或汇票有关；",
    setup279: "(g) 涉及货币兑换或支票兑现业务；",
    setup280: "(h)涉及某些信用修复或债务清偿服务、信用卡交易或保险活动，或",
    setup281: "(i) 涉及支付或接受与贿赂或腐败有关的款项。",
    setup282: "（4）涉及销售政府机构认定可能存在欺诈的产品或服务。",
    setup283: "您应对自己使用51shopy服务的行为承担法律责任，您应承担包括但不限于向被侵权人赔偿损失等法律责任，且在51shopy首先承担因用户行为导致行政处罚或侵权赔偿等法律责任后，您应向51shopy支付同等金额的赔偿金及51shopy因此受到的其他损失。",
    setup284: "8.赔偿责任",
    setup285: "1.如果由于您的行为导致51shopy和/或其关联公司遭受损失（包括直接经济损失、商誉损失以及赔偿、和解、律师费、保全保险、诉讼费等间接经济损失），您应当对51shopy和/或其关联公司的全部损失进行赔偿。",
    setup286: "2.如因您的行为导致51shopy及/或其关联公司受到第三方（包括但不限于淘宝、1688等平台卖家）索赔的，51shopy及/或其关联公司可在向该第三方承担金钱赔偿等义务后向您追偿全部损失。",
    setup287: "9.适用法律和管辖权",
    setup288: "1.本服务协议以及我们向您提供服务的任何单独协议均应受香港法律管辖并依其解释。",
    setup289: "2.因您使用51shopy服务所产生的任何纠纷，以及与51shopy服务相关的纠纷，51shopy应与您协商解决。协商不成的，任何一方均可向本协议签署地有管辖权的法院提起诉讼。",
    setup290: "以下为仓库出库（发往物流商仓库）/物流商提货时间表，仅供参考（实际时间表以各物流商安排为准）：",
    setup291: "包裹派送/取件时间：",
    setup292: "当包裹在51shopy仓库状态为“已打包”时，仓库和物流商会在固定时间内安排派送/提货（周末及节假日物流商休息，提货顺延）。",
    setup293: "航线",
    setup294: "派件/接件安排（北京时间）",
    setup295: "GD-EMS",
    setup296: "周一至周日取货",
    setup297: "GD-EUB",
    setup298: "周一至周日取货",
    setup299: "GD-E-EMS",
    setup300: "周一至周日取货",
    setup301: "EUB-T",
    setup302: "周一至周日取货",
    setup303: "敦豪速递",
    setup304: "周一至周六取货",
    setup305: "DHL重货标准快递",
    setup306: "周一至周六取货",
    setup307: "欧洲DHL专线",
    setup308: "周一至周日发货（送到物流商仓库）",
    setup309: "美国线（小）",
    setup310: "周一至周日发货（送到物流商仓库）",
    setup311: "英国线（小）",
    setup312: "周一至周日发货（送到物流商仓库）",
    setup313: "韩国EMS",
    setup314: "每天从我们的仓库发货",
    setup315: "PDB 邮政小包",
    setup316: "海包",
    setup317: "欧洲铁路",
    setup318: "香港联合包裹服务有限公司",
    setup319: "Aramex专线",
    setup320: "SAL",
    setup331: "EMS",
    setup332: "PD-EUB",
    setup333: "英国线",
    setup334: "NH-EMS",
    setup335: "欧洲免关税专线",
    setup336: "美国线",
    setup337: "圆通快递",
    setup338: "顺丰速运",
    setup339: "51shopy是一家提供中国商品购物、转运服务的平台，为用户提供商品信息搜索、购物及转运服务。期间，51shopy提供基本的商品检验服务、与商家的沟通确认以及售后服务，以保障您的合法权益，保证您的购物体验。",
    setup340: "如您发现购买的商品存在假冒伪劣问题，请联系我们的客服或者发送邮件至",
    setup341: "1.接收与检验：商品质量检查并入库51shopy仓库后，或者您收到包裹后，如发现商品存在质量问题或怀疑其真实性，请尽快联系客服并提供相关证据。",
    setup342: "2.投诉材料：提供所购商品的订单、付款凭证、商品的描述，以及商品假冒伪劣的证据描述。",
    setup343: "3.收到您的投诉材料后，我们的客服团队将与您了解具体情况并协助您与卖家沟通解决问题，尽力争取您的合法权益。",
    setup344: "请注意，由于涉及商品真伪，可能需要进一步的专业评估和法律程序。如需专业评估机构鉴定，评估费用将由您承担。为保障各方权益，我们建议在购买时选择正规渠道和信誉良好的卖家，以降低购买假冒商品的风险。",
    setup345: " 什么是 14 天退货/换货保证？",
    setup346: "五日退换货保障是第三方平台卖家为消费者提供的特殊售后服务（包括服务本身和技术支持），在商品签收后14日（即商品入库后14日内），买家可以依据本规则及第三方平台发布的相关规则对购买的商品进行退换货。",
    setup347: "如何确定产品是否符合退货/换货保证条件？",
    setup348: "产品要么“符合”14 天免费退换货服务的条件，要么“不符合”14 天免费退换货服务的条件",
    setup349: "是否可用",
    setup350: "类型",
    setup351: "例如",
    setup352: "不可用",
    setup353: "根据商家提供的信息确定，不能确认的我们将与卖家协商退货/换货事宜，但最终结果以卖家的决定为准。",
    setup354: "定制",
    setup355: "定制设计产品",
    setup356: "明确不支持退换的",
    setup357: "促销瑕疵品",
    setup358: "应用户要求已拆除包装、标签、附件的商品",
    setup359: "衣服标签被撕掉",
    setup360: "报纸、期刊",
    setup361: "已订阅的书籍和期刊",
    setup362: "二手产品",
    setup363: "中国大陆以外产品",
    setup364: "海外及港澳地区购入产品",
    setup365: "内衣",
    setup366: "内衣、袜子、打底裤",
    setup367: "成人用品",
    setup368: "卖方规定的其他事项",
    setup369: "遵守卖家规则",
    setup370: "食物",
    setup371: "饼干，糖果等",
    setup372: "图书（≥15本）",
    setup373: "不少于 15 本书",
    setup374: "已开封且需符合退货包装“特殊标准”的商品。",
    setup375: "密封产品请参考附表",
    setup376: "可用的",
    setup377: "对于入库后 14 天内提交的退/换货请求，我们将按照标准程序处理。",
    setup378: "当产品满足以下所有要求时：",
    setup379: "1. 卖方提供退货保证；",
    setup380: "2. 处于卖方要求的可重新销售的状态；",
    setup381: "3.入库时间未超过14天。",
    setup382: "对于提供免费送货优惠的产品，您将负责退回产品时的运费。对于不提供免费送货优惠的产品，您将负责卖家将产品运送到我们仓库时的运费和您将产品退回给卖家时的运费。",
    setup383: "如何申请退货/换货服务",
    setup384: "订单状态变为“已入库”后14天内（从状态变为“已入库”的下一个小时开始计算，14天=336小时）您可在页面申请退换货服务，超过时间可能无法受理申请。",
    setup385: "注意事项和常见问题",
    setup386: "笔记：",
    setup387: "退款/换货总额以您实际支付的产品价格为准",
    setup388: "仅当卖家同意时，我们才能为您退货/换货",
    setup389: "申请退/换货服务后，请确保您的账户中有足够的余额，以便支付退货运费和服务费。",
    setup390: "部分商品的退货包装要求请参见下表，若不满足要求，您将无法退货/换货。",
    setup391: "特殊标准",
    setup392: "产品分类",
    setup393: "特殊标准",
    setup394: "新款运动鞋",
    setup395: "防盗扣（如果有）和防损坏贴纸未被剪掉/移除，并且功能齐全。",
    setup396: "洗涤剂 / 卫生棉条 / 纸 / 香水",
    setup397: "个人护理产品的一次性密封包装（如果有）必须保持密封。",
    setup398: "头发护理/假发",
    setup399: "护发产品的一次性密封包装（如有）必须保持密封。",
    setup400: "皮肤护理/身体护理/精油",
    setup401: "产品的一次性密封包装（如有）必须保持密封",
    setup402: "化妆品/香水/美容工具",
    setup403: "数码产品/家用电器（不包括相机及大型家电）",
    setup404: "1.上网许可证未损坏（毁损）。",
    setup405: "2. 没有水损。",
    setup406: "数码相机/单反相机/照相机",
    setup407: "单反相机的快门按下次数不超过20次。",
    setup408: "大型家电",
    setup409: "1、液晶电视、空调：尚未安装到墙上，可进行简单调试。",
    setup410: "2.洗衣机：还未用水使用过。",
    setup411: "模型 / 动漫周边 / 动漫周边 / 角色扮演产品 / 棋盘游戏",
    setup412: "模型、手办、兵人模型、BJD等产品上的胶带和塑料封条（如果有）无法去除。",
    setup413: "电子元器件",
    setup414: "1.禁止焊接作业。",
    setup415: "2.集成电路从未被安装在任何IC基座上。",
    setup416: "3、导热硅脂/导热膏、电子胶/灌封胶/密封胶/胶粘剂、导电胶、导电墨水等耗材的一次性密封包装必须保持密封。",
    setup417: "一级类别“电子游戏/配件/游戏/游戏指南”下的二级类别“游戏软件”",
    setup418: "一级类别“宠物/宠物食品及用品”下的宠物食品、保健品和药品",
    setup419: "书籍/杂志",
    setup420: "1. 商品的一次性密封包装（如有）必须保持密封",
    setup421: "2、商品上无折叠、水渍、污渍、墨水、阅读时留下的痕迹。",
    setup422: "一级类别“畜牧/农产品”下的二级类别“动物保健产品/兽药”",
    setup423: "食品（包括补充剂）、化妆品、医疗器械、避孕药具、个人护理用品、成人用品、婴儿尿布、书籍和音像制品等产品的一次性密封包装（如果有）必须保持密封。",
    setup424: "“密封”是指：厂家在产品包装上采用的封条或塑料包装。",
    setup425: "常见问题：",
    setup426: "1. 不属于“退换货保障”的订单出现售后问题怎么办？",

    setup427: "当商品出现质量问题时，51shopy会根据实际情况与卖家核实，制定最终解决方案并通知用户。若商品无质量问题，则根据第三方平台规则，无法提供退换货服务。51shopy会尽力与卖家沟通，维护用户权益。",
    setup428: "2. 使用“退/换货保证”时，谁负责运费？",
    setup429: "申请退换货服务前，商品必须是全新且符合转售条件，如商品无质量问题，运费由用户承担，如商品存在质量问题，用户提交申请后，卖家将承担运费。",
    setup430: "3. 订单状态为未发货，要求退货服务是否需要收费？",
    setup431: "不用担心，这种情况是不会收费的。只有当退换货请求满足三个条件时，您才会被收费：第一，产品没有质量问题。第二，产品已经在仓库备货。第三，您已经用完了本月的免费退换货次数。所以，当产品还未发货时，我们不会向您收取任何费用。",
    setup432: "邮箱：",
    setup433: "电话：+85251387262",
    setup434: "地址：香港觀塘開源道 56 號大眾工業大廈 3 樓 341 室",
    setup435: "Powered By 51shopy - 太空網絡科技有限公司",
    setup436: "协助您处理",
    setup437: "昨日热卖",
    setup438: "热卖中",
    setup439: "已售",
    setup440: "支付失败",
    setup441: "等待支付邮费",
    setup442: "已支付邮费待钱庄确认",
    setup443: "邮费已支付",
    setup444: "规格",
    setup445: "实际付款",
    setup446: "建议您在取消订单仔细考虑，取消订单后，平台不承担责任！",
    setup447: "切换支付",
    setup448: "支付邮费",
    setup449: "商城订单",
    setup450: "更多",
    setup451: "商城订单",
    setup452: "代购订单",
    setup453: "发布",
    setup454: "卖出",
    setup455: "历史",
    setup456: "代购订单",
    setup457: "应付金额",
    setup458: "进入店铺",
    setup459: "查看更多",
    setup460: "收起",
    setup461: "进入",
    setup462: "产品已经卖完了。",
    setup463: "我们推荐以下类似产品",
    setup464: "类似产品",
    setup465: "免责声明",
    setup467: "包装是指产品的原始包装。如经检查，除产品本身外，物流包装将被拆除。为避免损坏产品，将保留必要的保护包装材料。如果您要求拆除包装，我们概不负责。",
    setup468: "国内综合运费 对于同一卖家的货物，运费偏差将由我方调整。",
    setup469: "每件产品，我们将免费为您拍摄 3-7 张照片。如果您对精美照片服务有额外要求，我们可能会收取少量服务费。",
    setup470: "定制产品不支持退货和换货。",
    setup471: "对于商家批准退换货的产品，您可以在订单状态变为“入库”后的14天内申请退换货，当您要求退换货时，您需要负担0.75美元左右的手续费，以及每种不同产品退货的国内运费，总金额约为3美元。",
    setup472: "全选",
    setup473: "邮费线路",
    setup474: "运费",
    setup475: "需要包裹的长度、宽度和高度信息",
    setup476: "运输时间",
    setup477: "天",
    setup478: "免税",
    setup479: "可以投保",
    setup480: "运费估算",
    setup481: "检索密码注册表",
    setup482: "商户",
    setup483: "请在",
    setup484: "付款，否则订单将被取消",
    setup485: "商品总价",
    setup486: "实付金额",
    setup487: "立即支付",
    setup488: "余额不足，请充值付款",
    setup489: "没有合适的付款方式？您可以先尝试使用余额付款",
    setup490: "已入库",
    setup491: "运费已报价",
    setup492: "已支付运费",
    setup493: "已出库",
    setup494: "继续支付",
    setup495: "国际物流单号",
    setup496: "国内物流单号",
    setup497: "您的浏览器不支持 HTML5 视频播放器。",
    setup498: "只支持上传 PNG 和 JPEG 格式的图片！",
    setup499: "完成",
    setup500: "返回",
    setup501: "你没有权限去该页面",
    setup502: "运输计算",
    setup503: "与多家物流公司合作，提供最优惠的折扣",
    setup504: "运费估算",
    setup505: "搜索商品",
    setup506: "根据搜索条件查看商品",
    setup507: "基础信息",
    setup508: "请输入英文名称",
    setup509: "请输入中文名称",
    setup510: "上传视频只能是 MP4、WebM 或 OGG 格式!",
    setup511: "上传视频大小不能超过 2MB!",
    setup512: "视频时长不能超过",
    setup513: "秒",
    setup514: "无法获取视频时长，请检查视频文件是否损坏",
    setup515: "数据",
    setup516: "",
    setup517: "请输入sku",
    setup518: "请输入数量",
    setup519: "请输入价格",
    setup520: "请输入英文商品详情",
    setup521: "请输入中文商品详情",
    setup522: "简体中文",
    setup523: "西班牙语",
    setup524: "葡萄牙语",
    setup525: "荷兰语",
    setup526: "波兰语",
    setup527: "德语",
    setup528: "法语",
    setup529: "意大利语",
    setup530: "启用多规格",
    setup531: "价格(CNY)",
    setup532: "添加规格图片",
    setup533: "添加规格值",
    setup534: "① 双击修改、拖动调整顺序",
    setup535: "添加规格",
    setup536: "批量设置",
    setup537: "请在pc端进行发布",
    setup538: "名称",
    setup539: "上传商品视频",
    setup540: "入库时间",
    setup541: "出库时间",
    setup542: "待钱庄确认",
    setup543: "我的发布",
    setup544: "发布商品前请先认证为商家",
    setup545: "请前往PC端发布商品",
    setup546: "目的地",
    setup547: "美国",
    setup548: "重量（克）",
    setup549: "产品类别",
    setup550: "请选择类别",
    setup551: "长度",
    setup552: "宽度",
    setup553: "高度",
    setup554: "查询",
    setup555: "综合",
    setup556: "可投保",
    setup557: "免税",
    setup558: "运费",
    setup559: "需要包裹长宽高信息",
    setup560: "运输时间",
    setup561: "天",
    setup562: "取消ustd支付成功！",
    setup563: "天提醒：请选择目的地国家，系统会搜索该地点的可用航线",
    setup564: "包裹限制",
    setup565: "最小重量限制：",
    setup566: "最大重量限制：",
    setup567: "体积重量计费规则：",
    setup568: "尺寸限制：",
    setup569: "无法发送",
    setup570: "可以发送",
    setup571: "收费标准：",
    setup572: "重量单位",
    setup573: "单价",
    setup574: "报关费",
    setup575: "燃油费",
    setup576: "操作费",
    setup577:"该银行信用额度不足，无法选择此银行！",
    setup578:"51币余额不足，请充值！",
    setup579: "备注",
    setup580:"请选择要删除的商品!",
    setup581:"使用谷歌登录",
    setup582:"默认第一张图片为商品主图，如需更改请拖拽图片",
    setup583:"已达到最大上传数量",
    setup584:"使用telegram登录",
    setup585:"查看物流",
    setup586:"物流信息",
    setup587:"修改物流单号",
    setup588:"绑定邮箱",
    setup589:"请先绑定邮箱",
    setup590:"规格类型最多填写2个！",
    setup591:"常用模版",
    setup592:"选择型号",
    setup593:"取消",
    setup594:"添加",
    setup595:"请选择规格值",
    setup596:"请勿重复添加",
    setup597:"设置常用模版成功！",
    setup598:"SKU不能为空",
    setup599:"价格不能为空",
    setup600:"数量不能为空",
    setup601:"无法添加相同规格值！",
    setup602:"① 双击修改",
    setup603:"请填写规格信息！",
    setup604:"请同时填写简体中文和英文的商品详情!",
    setup605:"修改成功",
    setup606:"添加规格值成功！",
    setup607:"设为常用",
    setup608:"至少填写一个规格值！",
    setup609:"请输入简体中文",
    setup610:"请输入English",
    setup611:"请输入西班牙语",
    setup612:"请输入葡萄牙语",
    setup613:"请输入荷兰语",
    setup614:"请输入波兰语",
    setup615:"请输入德语",
    setup616:"请输入法语",
    setup617:"请输入意大利语",
    setup618:"自动翻译",
    setup619:"翻译",
    setup620:"其他所有",
    setup621:"发货信息",
    setup622:"我们的目标是为您提供最佳的运输选择，无论您住在哪里。我们每天为全球数百家客户提供服务，我们努力为您提供最高水平的服务。",
    setup623:"A.订单交付的时间框架分为两部分：",
    setup624:"· 处理时间：3-7天",
    setup625:"· 运输时间：14~30天",
    setup626:"B.运输方式",
    setup627:"C.运费",
    setup628:"知识产权",
    setup629:"陆运/海运",
    setup630:"待收货",
    setup631:"联盟",
    setup632:"分享您的联盟代码",
    setup633:"您邀请的朋友确认收到您的联盟代码",
    setup634:"收到您的联盟佣金",
    setup635:"复制此 URL 并使用它将用户重定向到您的联盟 lD 的主页",
    setup636:"复制URL",
    setup637:"我的联盟",
    setup638:"记录",
    setup639:"领取",
    setup640:"权益FAQ",
    setup641:"什么是联盟会员计划？",
    setup642:"51Shopy是一个由所有用户发起的分享赚项目，无论你是个人还是卖家，加入一个51Shopy推广者，邀请新人在51Shopy上注册并成功购买，他/她就会成为你的专属用户，他/她的每一笔国际物流消费都会给你带来现金返利，返利金额可高达百万元，上不封顶。",
    setup643:"我的奖金是如何计算的？",
    setup644:"一旦成为会员，您的账户立即有返佣率，您邀请注册的国际物流货运用户越多，您获得的奖金越多，您的返佣率也会越高，当奖金达到一定金额时，您可以申请提现，也可以用它来抵扣51Shopy平台的任何服务费，返佣率为",
    setup645:"如何免费推广？",
    setup646:"通过点击产品页面上的共享复制您的促销链接或促销链接并将其发送给您的朋友。 当他们访问和注册时，他们将成为您的唯一用户。",
    setup647:'注册时间',
    setup648:'运输费用',
    setup649:'激活状态',
    setup650:'奖金记录',
    setup651:'申请时间',
    setup652:'总奖励',
    setup653:'邀请用户',
    setup654:'去钱包',
    setup655:"信用卡",
    setup656:"邀请好友享佣金",
    setup657:"联盟会员",
    setup658:"采购订单",
    setup659:"51Shopy 代理平台为您提供在中国线上和线下购买产品的帮助。只需提供产品链接并下订单,我们的团队将从始至终提供一流的服务",
    setup660:"发货到仓库",
    setup661:"通过我们,您可以从各个卖家那里购买产品,并将其运送到 51Shopy 在中国的仓库",
    setup662:"质检",
    setup663:"一旦您的物品到达 51Shopy 仓库,我们将进行彻底的质量检查,涵盖从缺陷、尺寸到颜色等所有内容。您可以放心, 51Shopy 提供可靠的售后服务保证。",
    setup664:"全球配送",
    setup665:"在 51Shopy 仓库,您可以自由选择和组合商品,并使用 51Shopy 提供的可靠物流服务将它们打包运送到您的家中。",
    setup666:"一站式服务,全程无忧",
    setup667:"您邀请的用户一旦注册即可获得美元：",
    setup668:"包邮",
    setup669:"不包邮",
    setup670:"不包含国际运费",
    setup671:"物流公司",
    setup672:"选择物流公司",
    setup673:"寄件人尾号",
    setup674:"后四位",
    setup675:"货主编号",
    setup676:"请输入",
    setup677:"待入库",
    setup678:"是否包含国际邮费",
    setup679:"是",
    setup680:"否",
    setup681:"点击'添加到主屏幕'按钮",
}